var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-snackbar',{attrs:{"top":_vm.y === 'top'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{staticClass:"primary--text",attrs:{"text":""},on:{"click":function($event){_vm.snackbar = false}}},[_vm._v("X")])],1),_c('v-content',{staticStyle:{"margin":"0","padding":"0"}},[(
        _vm.$route.name == 'FTTHApplication' ||
        _vm.$route.name == 'Tickets' ||
        _vm.$route.name == 'OrganisationApplication'||
        _vm.$route.name == 'PaymentSuccess'||
        _vm.$route.name == 'PaymentFailure'
      )?_c('router-view',{staticStyle:{"margin":"0","padding":"0"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }